<template>
  <div
    class="digital-article-view"
    :class="{ 'digital-article-view-mobile': isMobile, 'digital-article-view-share': isShare }"
    :style="{ width: width.toString().indexOf('%') === -1 ? width + 'px' : width }"
    v-if="show"
  >
    <div class="top" v-if="isTraditionalPage">
      <div class="top-btn-group">
        <div class="collect" @click="prev()">{{ currentLang === 1 ? 'Previous' : '上一篇' }}</div>
        <div class="collect" @click="next">{{ currentLang === 1 ? 'Next' : '下一篇' }}</div>
        <div class="collect" v-if="displayOrNot.collect === 1" @click="collect()">
          <img class="collect-button" :src="isCollect ? require('@imgs/digital/btn-collected.png') : require('@imgs/digital/btn-collect.png')" alt="收藏" />
        </div>
        <div class="collect" @click="share" v-if="displayOrNot.share === 1" :class="{ 'hide-close': !initShowClose }">
          <img src="@imgs/digital/share-black.png" />
        </div>
      </div>
    </div>
    <div class="top" v-else>
      <div class="txt" v-if="isMobile && !isShare">{{ currentLang === 1 ? 'Article' : '文章' }}</div>
      <div class="close" @click="close" v-show="initShowClose">
        <img src="@imgs/digital/close-black.png" />
      </div>
      <div class="back" @click="back" v-show="initShowBack">
        <img v-if="currentLang === 1" src="@imgs/digital/to-paper-en.png" />
        <img v-else src="@imgs/digital/to-paper.png" />
      </div>
      <div class="top-btn-group">
        <div class="collect" v-if="displayOrNot.collect === 1" @click="collect()">
          <img class="collect-button" :src="isCollect ? require('@imgs/digital/btn-collected.png') : require('@imgs/digital/btn-collect.png')" alt="收藏" />
        </div>
        <div class="login" v-if="displayOrNot.login === 1">
          <img src="@imgs/digital/digital-mine.png" alt="我的主页" @click="$router.push({ path: '/personal' })" v-if="isLogin" />
          <img src="@imgs/digital/digital-login.png" alt="登录" v-else @click="goLogin" />
        </div>
        <div class="share" @click="share" v-if="!isMobile && displayOrNot.share === 1" :class="{ 'hide-close': !initShowClose }">
          <img src="@imgs/digital/share-black.png" />
        </div>
      </div>
    </div>
    <div class="box" id="digital-article-view-box">
      <div class="text" id="digital-article-view-box-text" :class="[{ 'no-copy': copyText === 0 }, currentClassName]" v-dbtap="readSentence" v-html="articleText"></div>
      <div v-if="needPay" class="buy-button" @click="showOrder">
        <hr />
        <div v-if="currentLang === 1" class="buy-button-text" :class="{ en: currentLang === 1 }">The trial reading is over<br />Click to pay for full article</div>
        <div v-else class="buy-button-text">试读结束<br />点击购买完整内容</div>
      </div>
    </div>
    <div class="bottom">
      <div class="line"></div>
      <div class="btn prev" @click="prev" v-show="initShowPrevAndNext">
        <img src="@imgs/digital/prev-black.png" />
      </div>
      <div class="btn a-" @click="narrow">A-</div>
      <div class="btn a" @click="normal">A</div>
      <div class="btn a+" @click="enlarge">A+</div>
      <div class="btn read" @click="read">
        <img src="@imgs/digital/read-black-ani.gif" v-if="readStatus" />
        <img src="@imgs/digital/read-black.png" v-else />
      </div>
      <div class="btn next" @click="next" v-show="initShowPrevAndNext">
        <img src="@imgs/digital/next-black.png" />
      </div>
    </div>
    <order-dialog v-if="needPay && !isPaper" :article-id="articleId" :ebook-id="$parent.epaperId" type="article" ref="orderDialog" @collect="collect" @close="orderDialogClose"></order-dialog>
    <baozhi-order-dialog ref="orderDialog" v-else-if="isPaper && needPay" @collect="collect"></baozhi-order-dialog>
  </div>
</template>
<script>
import getBook from '@api/getBook'
import CryptoJS from 'crypto-js'
import { Base64 } from 'js-base64'
import { isLogin, convertEnName, formatDigitalArticle, getByteLength } from '@/utils'
import TransWorker from '../../plugins/transcode.worker.js'
import homeApi from '@api/home'
import chargeApi from '@api/chargeManager'
import OrderDialog from '@components/toolbar/components/OrderDialog.vue'
import BaozhiOrderDialog from '@components/toolbar/components/BaozhiOrderDialog.vue'
let APPID = ''
let API_SECRET = ''
let API_KEY = ''
let transWorker = new TransWorker()
function getWebsocketUrl() {
  return new Promise((resolve, reject) => {
    var apiKey = API_KEY
    var apiSecret = API_SECRET
    var url = 'wss://tts-api.xfyun.cn/v2/tts'
    var host = location.host
    var date = new Date().toGMTString()
    var algorithm = 'hmac-sha256'
    var headers = 'host date request-line'
    var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`
    var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
    var signature = CryptoJS.enc.Base64.stringify(signatureSha)
    var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
    var authorization = btoa(authorizationOrigin)
    url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
    resolve(url)
  })
}
class TTSRecorder {
  constructor({ speed = 50, voice = 50, pitch = 50, voiceName = 'x3_guange', appId = APPID, text = [], tte = 'UTF8', defaultText = '请输入您要合成的文本' } = {}) {
    this.speed = speed
    this.voice = voice
    this.pitch = pitch
    this.voiceName = voiceName
    this.text = text
    this.textIndex = 0
    this.tte = tte
    this.defaultText = defaultText
    this.appId = appId
    this.audioData = []
    this.rawAudioData = []
    this.audioDataOffset = 0
    this.status = 'init'
    this.ttsWSOpen = false
    transWorker.onmessage = (e) => {
      this.audioData.push(...e.data.data)
      this.rawAudioData.push(...e.data.rawAudioData)
    }
  }
  // 修改录音听写状态
  setStatus(status) {
    this.onWillStatusChange && this.onWillStatusChange(this.status, status)
    this.status = status
  }
  // 设置合成相关参数
  setParams({ speed, voice, pitch, text, voiceName, tte }) {
    speed !== undefined && (this.speed = speed)
    voice !== undefined && (this.voice = voice)
    pitch !== undefined && (this.pitch = pitch)
    text && (this.text = text)
    tte && (this.tte = tte)
    voiceName && (this.voiceName = voiceName)
    this.resetAudio()
  }
  // 连接websocket
  connectWebSocket() {
    this.setStatus('ttsing')
    let isFirstMessage = true
    return getWebsocketUrl().then((url) => {
      let ttsWS
      if ('WebSocket' in window) {
        ttsWS = new WebSocket(url)
      } else if ('MozWebSocket' in window) {
        ttsWS = new MozWebSocket(url)
      } else {
        alert('浏览器不支持WebSocket')
        return
      }
      this.ttsWS = ttsWS
      ttsWS.onopen = (e) => {
        this.ttsWSOpen = true
        if (this.text[this.textIndex]) {
          this.webSocketSend(this.text[this.textIndex])
        }
      }
      ttsWS.onmessage = (e) => {
        this.result(e.data)
        if (isFirstMessage) {
          this.playTimeout = setTimeout(() => {
            this.audioPlay()
          }, 100)
        }
        isFirstMessage = false
      }
      ttsWS.onerror = (e) => {
        clearTimeout(this.playTimeout)
        this.setStatus('errorTTS')
        // alert('WebSocket报错，请f12查看详情')
        this.ttsWSOpen = false
        console.error(`详情查看：${encodeURI(url.replace('wss:', 'https:'))}`)
      }
      ttsWS.onclose = (e) => {
        console.log(e)
        this.ttsWSOpen = false
      }
    })
  }
  // 处理音频数据
  transToAudioData(audioData) {}
  // websocket发送数据
  webSocketSend(text) {
    var params = {
      common: {
        app_id: this.appId // APPID
      },
      business: {
        aue: 'raw',
        auf: 'audio/L16;rate=16000',
        vcn: this.voiceName,
        speed: this.speed,
        volume: this.voice,
        pitch: this.pitch,
        bgs: 0,
        tte: this.tte
      },
      data: {
        status: 2,
        text: this.encodeText(text, this.tte === 'unicode' ? 'base64&utf16le' : '')
      }
    }
    this.ttsWS.send(JSON.stringify(params))
  }
  encodeText(text, encoding) {
    switch (encoding) {
      case 'utf16le': {
        let buf = new ArrayBuffer(text.length * 4)
        let bufView = new Uint16Array(buf)
        for (let i = 0, strlen = text.length; i < strlen; i++) {
          bufView[i] = text.charCodeAt(i)
        }
        return buf
      }
      case 'buffer2Base64': {
        let binary = ''
        let bytes = new Uint8Array(text)
        let len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        return window.btoa(binary)
      }
      case 'base64&utf16le': {
        return this.encodeText(this.encodeText(text, 'utf16le'), 'buffer2Base64')
      }
      default: {
        return Base64.encode(text)
      }
    }
  }
  // websocket接收数据的处理
  result(resultData) {
    let jsonData = JSON.parse(resultData)
    // 合成失败
    if (jsonData.code !== 0) {
      alert(`合成失败: ${jsonData.code}:${jsonData.message}`)
      console.error(`${jsonData.code}:${jsonData.message}`)
      this.resetAudio()
      return
    }
    transWorker.postMessage(jsonData.data.audio)

    if (jsonData.code === 0 && jsonData.data.status === 2) {
      this.ttsWS.close()
    }
  }
  // 重置音频数据
  resetAudio() {
    this.audioStop()
    this.setStatus('init')
    this.audioDataOffset = 0
    this.textIndex = 0
    this.audioData = []
    this.rawAudioData = []
    this.ttsWS && this.ttsWS.close()
    clearTimeout(this.playTimeout)
  }
  // 音频初始化
  audioInit() {
    let AudioContext = window.AudioContext || window.webkitAudioContext
    if (AudioContext) {
      this.audioContext = new AudioContext()
      this.audioContext.resume()
      this.audioDataOffset = 0
    }
  }
  // 音频播放
  audioPlay() {
    this.setStatus('play')
    let audioData = this.audioData.slice(this.audioDataOffset)
    this.audioDataOffset += audioData.length
    let audioBuffer = this.audioContext.createBuffer(1, audioData.length, 22050)
    let nowBuffering = audioBuffer.getChannelData(0)
    if (audioBuffer.copyToChannel) {
      audioBuffer.copyToChannel(new Float32Array(audioData), 0, 0)
    } else {
      for (let i = 0; i < audioData.length; i++) {
        nowBuffering[i] = audioData[i]
      }
    }
    let bufferSource = (this.bufferSource = this.audioContext.createBufferSource())
    bufferSource.buffer = audioBuffer
    bufferSource.connect(this.audioContext.destination)
    bufferSource.start()
    bufferSource.onended = (event) => {
      if (this.status !== 'play') {
        return
      }
      if (this.audioDataOffset < this.audioData.length) {
        this.audioPlay()
      } else if (this.ttsWSOpen) {
        setTimeout(() => {
          this.audioPlay()
        }, 1000)
      } else if (this.textIndex < this.text.length - 1) {
        this.textIndex++
        this.connectWebSocket()
      } else {
        this.audioStop()
      }
    }
  }
  // 音频播放结束
  audioStop() {
    this.setStatus('endPlay')
    clearTimeout(this.playTimeout)
    this.audioDataOffset = 0
    if (this.bufferSource) {
      try {
        this.bufferSource.stop()
      } catch (e) {
        console.log(e)
      }
    }
  }
  start() {
    if (this.audioData.length) {
      this.audioPlay()
    } else {
      if (!this.audioContext) {
        this.audioInit()
      }
      if (!this.audioContext) {
        alert('该浏览器不支持webAudioApi相关接口')
        return
      }
      this.connectWebSocket()
    }
  }
  stop() {
    this.audioStop()
    // 后续如果要从暂停出开始读，需要去掉
    this.ttsWS && this.ttsWS.close()
  }
}
export default {
  name: 'DigitalArticleView',
  components: { BaozhiOrderDialog, OrderDialog },
  props: {
    width: {
      type: [Number, String],
      default: 400
    },
    isShare: {
      type: Boolean,
      default: false
    },
    initShow: {
      type: Boolean,
      default: false
    },
    initShowBack: {
      type: Boolean,
      default: false
    },
    initShowClose: {
      type: Boolean,
      default: true
    },
    initShowPrevAndNext: {
      type: Boolean,
      default: true
    },
    initShowToPaper: {
      type: Boolean,
      default: true
    },
    epaperId: {
      type: String,
      default: ''
    },
    initArticleText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: this.initShow,
      articleText: this.initArticleText,
      articleReadText: this.initArticleText,
      currentClassIndex: 0,
      currentClassName: '',
      box: null,
      boxY: 0,
      boxTouchY: 0,
      voices: ['x3_guange', 'x4_lingxiaoying_en', 'x2_wanshu', 'xiaoyan', 'aisjiuxu', 'aisxping', 'aisjinger', 'aisbabyxu'],
      speeds: [50, 30, 70],
      readStatus: false,
      isCollect: false,
      collectId: false,
      title: '',
      articleId: '',
      creator: '',
      edition: 1,
      loginUrl: window.PROJECT_CONFIG.BASE_URL,
      hyperlinkid: '',
      needPay: false,
      lastDbtapTime: 0,
      currentUser: localStorage.getItem('username')
    }
  },
  watch: {
    initShow(show) {
      this.show = show
      this.initArticleStyle()
      if (show) {
        this.initVisibleText(this.initArticleText)
      }
    },
    initArticleText(articleText) {
      this.initVisibleText(articleText)
      const el = document.getElementById('digital-article-view-box')
      if (el) {
        el.scrollTop = -10
      }
      this.$nextTick(() => {
        // setTimeout(() => {
        const elements = document.querySelectorAll('[style="color: blue;"]')
        if (elements && elements.length > 0) {
          const regex = /hyperLinkId="(\d*)"/
          let matches = regex.exec(this.articleText)
          if (matches) {
            this.hyperlinkid = matches[1]
            elements[0].addEventListener('click', this.editorClick)
          }
        }
      })
      this.loadFtfont()
      setTimeout(() => {
        this.tcplayer()
      }, 100)
      // 如果正在朗读，则关闭朗读
      if (this.ttsRecorder) {
        if (this.readStatus) {
          this.ttsRecorder.stop()
        }
      }
      this.initArticleStyle()
    },
    readStatus(status) {
      if (!status) {
        this.articleReadText = this.articleText
      }
    },
    articleId() {
      this.getCollected()
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    voiceNumber() {
      return this.$route.query.voiceNumber && this.$route.query.voiceNumber !== '' ? this.$route.query.voiceNumber : this.$store.state.book.bookData.voiceNumber
    },
    voiceSpeed() {
      return this.$store.state.book.bookData.voiceSpeed
    },
    userVoiceSpeed() {
      return this.$store.state.book.bookData.userVoiceSpeed
    },
    sentenceRead() {
      return this.$store.state.book.bookData.sentenceRead
    },
    copyText() {
      return this.$store.state.book.bookData?.copyText
    },
    timer() {
      return this.$store.state.book.timer
    },
    displayOrNot() {
      return this.$store.state.config.bookObj.displayOrNot
    },
    isLogin() {
      return this.$store.state.common.isLogin
    },
    goodsObj() {
      return this.$store.state.common.goodsObj
    },
    isTraditionalPage() {
      return this.$store.state.book.bookData?.style === 1 && this.$store.state.book.isPaper && !this.isMobile && this.$route.path.indexOf('paper') > -1
    },
    isPaper() {
      return this.$parent.isPaper || this.$route.path.indexOf('paper') > -1
    },
    charge() {
      return this.$store.state.config.bookObj.charge
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    },
    languageOption() {
      return this.$store.state.config.languageOptions[this.currentLang]
    }
  },
  updated() {
    this.tcplayer()
  },
  mounted() {
    getBook.getTTSParam().then((res) => {
      if (res && res.data && res.status === 200) {
        APPID = res.data.data.appid
        API_KEY = res.data.data.apiKey
        API_SECRET = res.data.data.apiSecret
        this.ttsRecorder = new TTSRecorder()
        this.ttsRecorder.onWillStatusChange = (oldStatus, status) => {
          if (status === 'play') {
            this.readStatus = true
          } else if (status === 'endPlay') {
            this.readStatus = false
          }
        }
      }
    })
  },
  methods: {
    tcplayer() {
      let boxText = document.getElementById('digital-article-view-box-text')
      if (boxText) {
        let winWidth = window.innerWidth
        let videoWidth
        let videoElements = boxText.getElementsByTagName('video')
        if (window.location.href.indexOf('digitalArticle') !== -1) {
          if (this.isMobile) {
            videoWidth = winWidth - 30
          } else {
            videoWidth = 553
          }
        } else {
          videoWidth = 353
        }
        for (let a in videoElements) {
          if (videoElements.hasOwnProperty(a)) {
            let fileid = ''
            let appid = ''
            if (videoElements[a].firstChild.src) {
              let query = videoElements[a].firstChild.src.split('?')
              let params = query[1].split('&')
              params.forEach((item) => {
                let pam = item.split('=')
                if (pam[0] === 'fileid') {
                  fileid = pam[1]
                } else if (pam[0] === 'appid') {
                  appid = pam[1]
                }
              })
            }
            if (fileid && appid) {
              TCPlayer(videoElements[a], {
                fileID: fileid,
                appID: appid,
                width: videoWidth
              })
            }
          }
        }
      }
    },
    initArticleStyle() {
      this.$nextTick(() => {
        let abstracts = document.getElementsByClassName('content_type_0004')
        if (abstracts && abstracts.length > 0) {
          let last = abstracts[abstracts.length - 1]
          last.style['border-bottom'] = '1px dotted #777777'
        }
      })
    },
    initVisibleText(articleText) {
      let currentPage = parseInt(this.edition)
      if (this.$store.state.common.isOrdered || this.charge === 0 || (this.goodsObj.trialOption === 0 && this.goodsObj.chargePage >= currentPage) || this.goodsObj.creator === this.currentUser) {
        this.needPay = false
        this.articleText = articleText
        this.articleReadText = this.articleText
        return
      }
      if (!this.$parent.isPaper) {
        let params = { articleId: this.articleId, ebookId: this.$parent.epaperId }
        if (this.$route.query.albumId && this.$route.query.albumId !== 'undefined') {
          params.albumId = this.$route.query.albumId
        }
        chargeApi.queryArticleReadable(params).then((res) => {
          if (res.data?.status !== 0) {
            if (this.goodsObj.trialOption === 1) {
              this.changeArticleText(articleText)
            } else {
              this.articleText = ''
              this.needPay = true
              if (this.$store.state.book.isShowDigitalArticleView) {
                this.showOrder()
              }
            }
          } else {
            this.needPay = false
            this.articleText = articleText
          }
          this.articleReadText = this.articleText
        })
      } else {
        if (currentPage > this.goodsObj.chargePage) {
          this.articleText = ''
          this.needPay = true
          if (this.$store.state.book.isShowDigitalArticleView && !this.$store.state.book.orderDialogVisible) {
            this.showOrder()
          }
        } else {
          this.changeArticleText(articleText)
        }
        this.articleReadText = this.articleText
      }
    },
    changeArticleText(articleText) {
      this.needPay = true
      let articleArray = articleText.split(/<\/div>|<br>/)
      const articleNoHtmlText = articleText.replace(/<[^>]+>/g, '')
      let showTextArray = []
      let articleLength = 0
      let index = 0
      let trialPercent = this.goodsObj.trialOption === 1 ? this.goodsObj.trialPercent : 100
      let length = (articleNoHtmlText.length * trialPercent) / 100
      while (articleLength < length) {
        articleLength += articleArray[index].replace(/<[^>]+>/g, '').length
        if (articleLength > length) {
          break
        }
        showTextArray.push(articleArray[index] + '</div>')
        index++
      }
      this.articleText = showTextArray.join('')
    },
    readSentence(e) {
      if (this.sentenceRead && this.readStatus) {
        let currentTime = new Date().getTime()
        if (currentTime - this.lastClickTime < 2000) {
          return
        }
        this.lastClickTime = currentTime
        this.ttsRecorder.stop()
        let htmlText = e.target.innerText
        this.articleReadText = htmlText + this.articleText.split(htmlText)[1]
        this.read()
      }
    },
    getCollected() {
      //获取收藏状态
      let param = {
        worksId: this.articleId,
        worksType: 'cloud_read_article'
      }
      homeApi.findOneCollect(param).then((res) => {
        if (res.data.status === 0) {
          this.collectId = this.articleId
          this.isCollect = true
        } else {
          this.isCollect = false
          this.collectId = ''
        }
      })
    },
    editorClick() {
      const params = {
        id: this.hyperlinkid,
        sentenceRead: this.sentenceRead
      }
      getBook.getXiaoYangDetail(params).then((res) => {
        res = formatDigitalArticle(res)
        if (res.data.status == 0) {
          this.articleText = res.data.data.content
        }
      })
    },
    click(e) {
      if (this.isMobile && e.type === 'singletap' && e.target.className.indexOf('fd-js-excludes') < 0) {
        clearTimeout(this.timer)
        // this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        // this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
      }
    },
    share() {
      this.$emit('onShare')
    },
    close() {
      if (this.ttsRecorder) {
        if (this.readStatus) {
          this.ttsRecorder.stop()
        }
      }
      this.show = false
      this.$emit('onClose')
    },
    back() {
      if (this.ttsRecorder) {
        if (this.readStatus) {
          this.ttsRecorder.stop()
        }
      }
      this.show = false
      this.$emit('onBack')
    },
    prev() {
      this.$emit('onPrev')
      setTimeout(() => {
        this.box = document.getElementById('digital-article-view-box')
        this.box.scrollTop = 0
      }, 500)
    },
    narrow() {
      this.currentClassIndex -= 2
      if (this.currentClassIndex < -10) {
        this.currentClassIndex = -10
      }
      if (this.currentClassIndex < 0) {
        this.currentClassName = 'text__' + Math.abs(this.currentClassIndex)
      } else if (this.currentClassIndex === 0) {
        this.currentClassName = ''
      } else if (this.currentClassIndex > 0) {
        this.currentClassName = 'text_' + this.currentClassIndex
      }
    },
    normal() {
      this.currentClassIndex = 0
      this.currentClassName = ''
    },
    enlarge() {
      this.currentClassIndex += 2
      if (this.currentClassIndex > 10) {
        this.currentClassIndex = 10
      }
      if (this.currentClassIndex < 0) {
        this.currentClassName = 'text__' + Math.abs(this.currentClassIndex)
      } else if (this.currentClassIndex === 0) {
        this.currentClassName = ''
      } else if (this.currentClassIndex > 0) {
        this.currentClassName = 'text_' + this.currentClassIndex
      }
    },
    read() {
      if (this.ttsRecorder) {
        if (this.readStatus) {
          this.ttsRecorder.stop()
        } else {
          let voiceId = this.voiceNumber ? this.voiceNumber - 1 : 0
          let articleTextArray = this.articleReadText.split(/<\/div>|<br>/)
          let textArr = []
          let text = ''
          let textLength = 0
          for (let a in articleTextArray) {
            if (articleTextArray.hasOwnProperty(a)) {
              articleTextArray[a] = articleTextArray[a].replace(/<[^>]+>/g, '')
              if (!articleTextArray[a]) {
                continue
              }
              let lastChar = articleTextArray[a].substr(articleTextArray[a].length - 1, 1)
              if (!(lastChar === '。' || lastChar === '！')) {
                articleTextArray[a] += '。'
              }
              articleTextArray[a] = convertEnName(articleTextArray[a])
              const len = getByteLength(articleTextArray[a])
              textLength += len
              if (textLength >= 8000) {
                textArr.push(text)
                text = ''
                textLength = len
              }
              text += articleTextArray[a]
            }
          }
          textArr.push(text)
          let text1 = textArr.join('')
          let validText = text1.match(/[\u4e00-\u9fa5\uf900-\ufa2da-zA-Z0-9.。，：]/g)
          if (validText.length / text1.length > 0.5) {
            setTimeout(() => {
              this.ttsRecorder.setParams({
                text: textArr,
                voiceName: this.voices[voiceId],
                speed: this.voiceSpeed === 3 ? this.userVoiceSpeed : this.speeds[this.voiceSpeed]
              })
              this.ttsRecorder.start()
            }, 1300)
          } else {
            this.$alert('暂不支持该语种')
          }
        }
      }
    },
    next() {
      this.$emit('onNext')
      setTimeout(() => {
        this.box = document.getElementById('digital-article-view-box')
        this.box.scrollTop = 0
      }, 500)
    },
    loadFtfont() {
      // 加载方正云字体
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = window.PROJECT_CONFIG.FONT_API_URL
      script.onload = () => {
        // 设置字体
        let fontCfg = {
          p: 'rIgV4ZlDZrprpbtH',
          fonts: [
            {
              // 方正悠宋 GBK 509R
              fontName: 'FZYouSK_509R',
              selecters: ['.content_type_0001', '.content_type_0003', '.content_type_0008']
            },
            {
              // 方正悠黑_GBK 511M
              fontName: 'FZYouHK_511M',
              selecters: ['.content_type_0002']
            },
            {
              // 方正汉文正楷
              fontName: 'FZHanWZKJW',
              selecters: ['.content_type_0009']
            },
            {
              // 方正悠宋 GBK 507R
              fontName: 'FZYouS_507R',
              selecters: ['.content_type_0004', '.content_type_0005', '.content_type_0006', '.content_type_0007']
            }
          ]
        }
        setTimeout(() => {
          new FTFont(fontCfg)
        }, 1000)
      }
      document.body.appendChild(script)
    },
    async collect(type) {
      await isLogin()
      let param = {
        worksId: this.articleId,
        worksName: this.title,
        creator: this.creator,
        worksType: 'cloud_read_article'
      }
      if (this.isCollect && type !== 'order') {
        homeApi.cancelCollect({ ids: this.collectId }).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.unsubscribed,
              type: 'success'
            })
            this.isCollect = false
            this.collectId = ''
          }
        })
      } else {
        homeApi.collectWork(param).then((res) => {
          if (res.data.status === 0) {
            this.$message({
              message: this.languageOption.addedToFavorites,
              type: 'success'
            })
            this.isCollect = true
            this.collectId = res.data.data.id
          } else {
            this.$message({
              message: res.data.message || '收藏失败',
              type: 'error'
            })
          }
        })
      }
    },
    showOrder() {
      this.$refs.orderDialog.dialogVisible = true
      this.$store.commit('book/UPDATE_ORDER_DIALOG_VISIBLE', true)
    },
    orderDialogClose() {
      this.$store.commit('book/UPDATE_ORDER_DIALOG_VISIBLE', false)
    },
    goLogin() {
      window.location.href = this.loginUrl + '/fxsso/login?service=' + window.encodeURIComponent(window.location.href.replace('&from=content', ''))
    }
  },
  destroyed() {
    if (this.ttsRecorder) {
      if (this.readStatus) {
        this.ttsRecorder.stop()
      }
    }
  }
}
</script>
<style lang="scss">
.digital-article-view {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background: #f3f3f3;
  z-index: 999;
  .top {
    position: relative;
    height: 50px;
    .txt {
      display: block;
      width: 100%;
      line-height: 40px;
      text-align: center;
      color: #3a3a3a;
      font-weight: bold;
      font-size: 16px;
    }
    .share {
      text-align: center;
      cursor: pointer;
      img {
        margin-top: 12px;
        width: 26px;
        height: 26px;
      }
    }
    .hide-close {
      right: 0;
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 50px;
      text-align: center;
      cursor: pointer;
      img {
        margin-top: 12px;
        width: 26px;
        height: 26px;
      }
    }
    .back {
      position: absolute;
      top: 0;
      left: 0;
      width: 106px;
      margin-left: 10px;
      height: 50px;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        height: 27px;
        margin-right: 3px;
      }
    }
    .top-btn-group {
      position: absolute;
      top: 0;
      right: 43px;
      min-width: 100px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .login {
      cursor: pointer;
      height: 30px;
      margin-right: 10px;
      img {
        height: 30px;
      }
    }
    .collect {
      cursor: pointer;
      margin-right: 10px;
      img {
        width: 26px;
      }
    }
  }
  .box {
    word-wrap: break-word;
    overflow: auto;
    height: calc(100% - 95px);
    padding: 0 15px 0 15px;
    font-size: 14px;
    .buy-button {
      text-align: center;
      color: #df5813;
      margin-top: 30px;
      margin-bottom: 20px;
      hr {
        border-color: #df5813;
      }
      .buy-button-text {
        margin: -30px auto 0;
        width: 150px;
        background-color: #f4f4f4;
        cursor: pointer;
        &.en {
          width: 200px;
        }
      }
    }
    .text {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      -webkit-user-drag: auto !important;
      font-size: 16px;
      line-height: 29px;
      &.no-copy {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      img {
        /* 全局图片 */
        display: block !important;
        margin: auto !important;
        max-width: 100% !important;
      }
      audio {
        /* 全局音频 */
        max-width: 100% !important;
      }
      video {
        /* 全局视频 */
        display: block !important;
        margin: auto !important;
        max-width: 100% !important;
      }
      .content_audio {
        /* 音频元素独立样式控制 */
        display: block !important;
        margin: auto !important;
        width: 100% !important;
        background: #f3f3f3 !important;
        font-size: 0 !important;
        line-height: 0 !important;
      }
      .content_type_0001 {
        /* 引题 */
        font-size: 16px !important;
        line-height: 28px !important;
        text-align: justify;
        color: #777777 !important;
      }
      .content_type_0002 {
        /* 标题 */
        font-size: 22px !important;
        line-height: 34px !important;
        text-align: justify;
        color: #000000 !important;
      }
      .content_type_0003 {
        /* 副标题 */
        font-size: 16px !important;
        line-height: 28px !important;
        text-align: justify;
        color: #777777 !important;
        margin-top: 20px;
      }
      .content_type_0004 {
        /* 摘要 */
        font-size: 16px !important;
        line-height: 28px !important;
        text-align: justify;
        color: #000000 !important;
        text-indent: 0.8em !important;
        margin: 20px 0 !important;
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        &:first-of-type {
          border-top: 1px dotted #777777 !important;
        }
        &:last-of-type {
          border-bottom: 1px dotted #777777 !important;
        }
      }
      .content_type_0005 {
        /* 作者 */
        font-size: 14px !important;
        line-height: 22px !important;
        text-align: left;
        color: #777777 !important;
        margin-top: 20px;
      }
      .content_type_0006 {
        /* 图片说明 */
        font-size: 14px !important;
        line-height: 22px !important;
        text-align: center;
        color: #777777 !important;
      }
      .content_type_0007 {
        /* 内容 */
        font-size: 16px !important;
        line-height: 29px !important;
        text-align: justify;
        color: #000000 !important;
        text-indent: 2em;
        margin-top: 20px;
        img {
          display: inline !important;
          height: 16px;
        }
      }
      .content_type_0008 {
        /* 小标题 */
        font-size: 16px !important;
        line-height: 29px !important;
        text-align: justify;
        color: #000000 !important;
        margin: 12px 0 !important;
      }
      .content_type_0009 {
        /* 来源 */
        font-size: 12px !important;
        line-height: 18px !important;
        text-align: left;
        margin-left: 5em !important;
        text-indent: 0 !important;
        color: #000000 !important;
      }
      .content_type_0006 img {
        height: auto !important;
      }
    }
    .text_2 {
      font-size: 18px;
      line-height: 31px;
      .content_type_0001 {
        font-size: 18px !important;
        line-height: 30px !important;
      }
      .content_type_0002 {
        font-size: 24px !important;
        line-height: 36px !important;
      }
      .content_type_0003 {
        font-size: 18px !important;
        line-height: 30px !important;
      }
      .content_type_0004 {
        font-size: 18px !important;
        line-height: 30px !important;
      }
      .content_type_0005 {
        font-size: 16px !important;
        line-height: 24px !important;
      }
      .content_type_0006 {
        font-size: 16px !important;
        line-height: 24px !important;
      }
      .content_type_0007 {
        font-size: 18px !important;
        line-height: 31px !important;
        img {
          display: inline !important;
          height: 18px !important;
        }
      }
      .content_type_0008 {
        font-size: 18px !important;
        line-height: 31px !important;
      }
      .content_type_0009 {
        font-size: 14px !important;
        line-height: 20px !important;
      }
      .content_type_0006 img {
        height: auto !important;
      }
    }
    .text_4 {
      font-size: 20px;
      line-height: 33px;
      .content_type_0001 {
        font-size: 20px !important;
        line-height: 32px !important;
      }
      .content_type_0002 {
        font-size: 26px !important;
        line-height: 38px !important;
      }
      .content_type_0003 {
        font-size: 20px !important;
        line-height: 32px !important;
      }
      .content_type_0004 {
        font-size: 20px !important;
        line-height: 32px !important;
      }
      .content_type_0005 {
        font-size: 18px !important;
        line-height: 26px !important;
      }
      .content_type_0006 {
        font-size: 18px !important;
        line-height: 26px !important;
      }
      .content_type_0007 {
        font-size: 20px !important;
        line-height: 33px !important;
        img {
          display: inline !important;
          height: 20px !important;
        }
      }
      .content_type_0008 {
        font-size: 20px !important;
        line-height: 33px !important;
      }
      .content_type_0009 {
        font-size: 16px !important;
        line-height: 22px !important;
      }
      .content_type_0006 img {
        height: auto !important;
      }
    }
    .text_6 {
      font-size: 22px;
      line-height: 35px;
      .content_type_0001 {
        font-size: 22px !important;
        line-height: 34px !important;
      }
      .content_type_0002 {
        font-size: 28px !important;
        line-height: 40px !important;
      }
      .content_type_0003 {
        font-size: 22px !important;
        line-height: 34px !important;
      }
      .content_type_0004 {
        font-size: 22px !important;
        line-height: 34px !important;
      }
      .content_type_0005 {
        font-size: 20px !important;
        line-height: 28px !important;
      }
      .content_type_0006 {
        font-size: 20px !important;
        line-height: 28px !important;
      }
      .content_type_0007 {
        font-size: 22px !important;
        line-height: 35px !important;
        img {
          display: inline !important;
          height: 22px !important;
        }
      }
      .content_type_0008 {
        font-size: 22px !important;
        line-height: 35px !important;
      }
      .content_type_0009 {
        font-size: 18px !important;
        line-height: 24px !important;
      }
      .content_type_0006 img {
        height: auto !important;
      }
    }
    .text_8 {
      font-size: 24px;
      line-height: 37px;
      .content_type_0001 {
        font-size: 24px !important;
        line-height: 36px !important;
      }
      .content_type_0002 {
        font-size: 30px !important;
        line-height: 42px !important;
      }
      .content_type_0003 {
        font-size: 24px !important;
        line-height: 36px !important;
      }
      .content_type_0004 {
        font-size: 24px !important;
        line-height: 36px !important;
      }
      .content_type_0005 {
        font-size: 22px !important;
        line-height: 30px !important;
      }
      .content_type_0006 {
        font-size: 22px !important;
        line-height: 30px !important;
      }
      .content_type_0007 {
        font-size: 24px !important;
        line-height: 37px !important;
        img {
          display: inline !important;
          height: 24px !important;
        }
      }
      .content_type_0008 {
        font-size: 24px !important;
        line-height: 37px !important;
      }
      .content_type_0009 {
        font-size: 20px !important;
        line-height: 26px !important;
      }
      .content_type_0006 img {
        height: auto !important;
      }
    }
    .text_10 {
      font-size: 26px;
      line-height: 39px;
      .content_type_0001 {
        font-size: 26px !important;
        line-height: 38px !important;
      }
      .content_type_0002 {
        font-size: 32px !important;
        line-height: 44px !important;
      }
      .content_type_0003 {
        font-size: 26px !important;
        line-height: 38px !important;
      }
      .content_type_0004 {
        font-size: 26px !important;
        line-height: 38px !important;
      }
      .content_type_0005 {
        font-size: 24px !important;
        line-height: 32px !important;
      }
      .content_type_0006 {
        font-size: 24px !important;
        line-height: 32px !important;
      }
      .content_type_0007 {
        font-size: 26px !important;
        line-height: 39px !important;
        img {
          display: inline !important;
          height: 26px !important;
        }
      }
      .content_type_0008 {
        font-size: 26px !important;
        line-height: 39px !important;
      }
      .content_type_0009 {
        font-size: 22px !important;
        line-height: 28px !important;
      }
      .content_type_0006 img {
        height: auto !important;
      }
    }
    .text__2 {
      font-size: 14px;
      line-height: 27px;
      .content_type_0001 {
        font-size: 14px !important;
        line-height: 26px !important;
      }
      .content_type_0002 {
        font-size: 20px !important;
        line-height: 32px !important;
      }
      .content_type_0003 {
        font-size: 14px !important;
        line-height: 26px !important;
      }
      .content_type_0004 {
        font-size: 14px !important;
        line-height: 26px !important;
      }
      .content_type_0005 {
        font-size: 12px !important;
        line-height: 20px !important;
      }
      .content_type_0006 {
        font-size: 12px !important;
        line-height: 20px !important;
      }
      .content_type_0007 {
        font-size: 14px !important;
        line-height: 27px !important;
        img {
          display: inline !important;
          height: 14px !important;
        }
      }
      .content_type_0008 {
        font-size: 14px !important;
        line-height: 27px !important;
      }
      .content_type_0009 {
        font-size: 10px !important;
        line-height: 26px !important;
      }
      .content_type_0006 img {
        display: block;
        height: auto !important;
      }
    }
    .text__4 {
      font-size: 12px;
      line-height: 25px;
      .content_type_0001 {
        font-size: 12px !important;
        line-height: 24px !important;
      }
      .content_type_0002 {
        font-size: 18px !important;
        line-height: 30px !important;
      }
      .content_type_0003 {
        font-size: 12px !important;
        line-height: 24px !important;
      }
      .content_type_0004 {
        font-size: 12px !important;
        line-height: 24px !important;
      }
      .content_type_0005 {
        font-size: 10px !important;
        line-height: 18px !important;
      }
      .content_type_0006 {
        font-size: 10px !important;
        line-height: 18px !important;
      }
      .content_type_0007 {
        font-size: 12px !important;
        line-height: 25px !important;
        img {
          display: inline !important;
          height: 12px !important;
        }
      }
      .content_type_0008 {
        font-size: 12px !important;
        line-height: 25px !important;
      }
      .content_type_0009 {
        font-size: 8px !important;
        line-height: 14px !important;
      }
      .content_type_0006 img {
        display: block;
        height: auto !important;
      }
    }
    .text__6 {
      font-size: 10px;
      line-height: 23px;
      .content_type_0001 {
        font-size: 10px !important;
        line-height: 22px !important;
      }
      .content_type_0002 {
        font-size: 16px !important;
        line-height: 28px !important;
      }
      .content_type_0003 {
        font-size: 10px !important;
        line-height: 22px !important;
      }
      .content_type_0004 {
        font-size: 10px !important;
        line-height: 22px !important;
      }
      .content_type_0005 {
        font-size: 8px !important;
        line-height: 16px !important;
      }
      .content_type_0006 {
        font-size: 8px !important;
        line-height: 16px !important;
      }
      .content_type_0007 {
        font-size: 10px !important;
        line-height: 23px !important;
        img {
          display: inline !important;
          height: 10px !important;
        }
      }
      .content_type_0008 {
        font-size: 10px !important;
        line-height: 23px !important;
      }
      .content_type_0009 {
        font-size: 6px !important;
        line-height: 12px !important;
      }
      .content_type_0006 img {
        display: block;
        height: auto !important;
      }
    }
    .text__8 {
      font-size: 8px;
      line-height: 21px;
      .content_type_0001 {
        font-size: 8px !important;
        line-height: 20px !important;
      }
      .content_type_0002 {
        font-size: 14px !important;
        line-height: 26px !important;
      }
      .content_type_0003 {
        font-size: 8px !important;
        line-height: 20px !important;
      }
      .content_type_0004 {
        font-size: 8px !important;
        line-height: 20px !important;
      }
      .content_type_0005 {
        font-size: 6px !important;
        line-height: 14px !important;
      }
      .content_type_0006 {
        font-size: 6px !important;
        line-height: 14px !important;
      }
      .content_type_0007 {
        font-size: 8px !important;
        line-height: 21px !important;
        img {
          display: inline !important;
          height: 8px !important;
        }
      }
      .content_type_0008 {
        font-size: 8px !important;
        line-height: 21px !important;
      }
      .content_type_0009 {
        font-size: 6px !important;
        line-height: 14px !important;
      }
      .content_type_0006 img {
        display: block;
        height: auto !important;
      }
    }
    .text__10 {
      font-size: 6px;
      line-height: 19px;
      .content_type_0001 {
        font-size: 6px !important;
        line-height: 18px !important;
      }
      .content_type_0002 {
        font-size: 12px !important;
        line-height: 24px !important;
      }
      .content_type_0003 {
        font-size: 6px !important;
        line-height: 18px !important;
      }
      .content_type_0004 {
        font-size: 6px !important;
        line-height: 18px !important;
      }
      .content_type_0005 {
        font-size: 4px !important;
        line-height: 12px !important;
      }
      .content_type_0006 {
        font-size: 4px !important;
        line-height: 12px !important;
      }
      .content_type_0007 {
        font-size: 6px !important;
        line-height: 19px !important;
        img {
          display: inline !important;
          height: 6px !important;
        }
      }
      .content_type_0008 {
        font-size: 6px !important;
        line-height: 19px !important;
      }
      .content_type_0009 {
        font-size: 4px !important;
        line-height: 12px !important;
      }
    }
    .content_type_0006 img {
      display: block;
      height: auto !important;
    }
  }
  .bottom {
    position: relative;
    display: flex;
    height: 45px;
    bottom: 0;
    .line {
      position: absolute;
      top: 0;
      left: 6%;
      width: 88%;
      height: 1px;
      background: #e3e3e3;
    }
    .btn {
      flex: 1;
      text-align: center;
      line-height: 45px;
      font-size: 24px;
      cursor: pointer;
      img {
        margin-top: 10px;
        width: 26px;
        height: 26px;
      }
    }
  }
}
.digital-article-view-mobile {
  z-index: 999;
  background: #ffffff;
  -webkit-touch-callout: default;
  .top {
    background: #f5f5f5;
    height: 40px;
    .close {
      width: 40px;
      height: 40px;
      img {
        margin-top: 7px;
      }
    }
    .back {
      width: 100px;
      height: 40px;
      text-align: left;
      line-height: 40px;
      img {
        margin-right: 3px;
        margin-top: 0;
      }
      span {
        line-height: 40px;
      }
    }
    .top-btn-group {
      right: 0;
      height: 40px;
    }
  }
  .box {
    padding-top: 10px;
    padding-bottom: 10px;
    height: calc(100% - 85px);
    .buy-button {
      .buy-button-text {
        background-color: #fff;
      }
    }
    .text {
      .content_type_0009 {
        /* 来源 */
        font-size: 16px !important;
        line-height: 24px !important;
        text-align: left;
        color: #000000 !important;
      }
    }
    .text_2 {
      .content_type_0009 {
        /* 来源 */
        font-size: 18px !important;
        line-height: 26px !important;
      }
    }
    .text_4 {
      .content_type_0009 {
        /* 来源 */
        font-size: 20px !important;
        line-height: 28px !important;
      }
    }
    .text_6 {
      .content_type_0009 {
        /* 来源 */
        font-size: 22px !important;
        line-height: 30px !important;
      }
    }
    .text_8 {
      .content_type_0009 {
        /* 来源 */
        font-size: 24px !important;
        line-height: 32px !important;
      }
    }
    .text_10 {
      .content_type_0009 {
        /* 来源 */
        font-size: 26px !important;
        line-height: 34px !important;
      }
    }
    .text__2 {
      .content_type_0009 {
        /* 来源 */
        font-size: 14px !important;
        line-height: 22px !important;
      }
    }
    .text__4 {
      .content_type_0009 {
        /* 来源 */
        font-size: 12px !important;
        line-height: 20px !important;
      }
    }
    .text__6 {
      .content_type_0009 {
        /* 来源 */
        font-size: 10px !important;
        line-height: 18px !important;
      }
    }
    .text__8 {
      .content_type_0009 {
        /* 来源 */
        font-size: 8px !important;
        line-height: 16px !important;
      }
    }
    .text__10 {
      .content_type_0009 {
        /* 来源 */
        font-size: 6px !important;
        line-height: 14px !important;
      }
    }
  }
}
.digital-article-view-share {
  z-index: 999;
  background: #f3f3f3;
  .box {
    padding-top: 10px;
    padding-bottom: 10px;
    height: calc(100% - 95px);
    .buy-button {
      .buy-button-text {
        background-color: #f4f4f4;
      }
    }
  }
}
.paper-turn-digital-article-view {
  background: #f3f3f3;
  width: 510px;
  height: 695px;
  display: inline-block;
  vertical-align: top;
  flex-shrink: 0;
  position: relative;
  z-index: 5;
  .top {
    .top-btn-group {
      padding-top: 10px;
      right: 10px;
    }
  }
}
.video-js {
  margin: auto;
}
</style>
<style>
.content_type_0004:not(.content_type_0004 ~ .content_type_0004) {
  /* 摘要 */
  border-top: 1px dotted #777777 !important;
}
.content_type_0004:last-of-type {
  /* 摘要 */
  border-bottom: 1px dotted #777777 !important;
}
</style>
